import React from 'react'
import DurationFromSecondsValue from 'support/displays/DurationFromSecondsValue'
import useInterval from 'support/hooks/use-interval'
import { useValue } from '@morningtrain/react-resources'
import { observer } from 'mobx-react'

function ToggleTicker () {
  const startValue = useValue('current_toggle_duration', 0)
  const isToggleRunning = useValue('is_toggle_running')

  const [elapsed, setElapsed] = React.useState(startValue)

  React.useEffect(() => {
    setElapsed(startValue)
  }, [startValue])

  useInterval(() => {
    if (isToggleRunning) {
      setElapsed(elapsed + 1)
    } else {
      setElapsed(0)
    }
  }, 1000)

  return (
    <DurationFromSecondsValue seconds={elapsed} />
  )
}

export default observer(ToggleTicker)
